export function curriculumValidation(err = "Arquivo Inválido") {
  return (v) => {
    if (!v) return err;

    let fileNameSplit = v.name.split(".");

    return (
      (!!v &&
        (fileNameSplit.at(-1) === "pdf" ||
          fileNameSplit.at(-1) === "docx" ||
          fileNameSplit.at(-1) === "doc")) ||
      err
    );
  };
}
